export type ConsentStatus = 'granted' | 'denied'

const STORAGE_KEY = 'roofora-cookie-consent'

/** No stored value yet means "never decided" - distinct from an explicit 'denied', so the banner
 *  keeps showing until the visitor actually makes a choice, but never reappears once they have
 *  (in either direction) until they use "Cookie-Einstellungen" (see LegalLinks.tsx) to reopen it. */
export function getStoredConsent(): ConsentStatus | null {
  const value = window.localStorage.getItem(STORAGE_KEY)
  return value === 'granted' || value === 'denied' ? value : null
}

export function setStoredConsent(status: ConsentStatus): void {
  window.localStorage.setItem(STORAGE_KEY, status)
}
